import { isBrowser } from './dom'
import { queryParams } from './url'

export const getRouterState = () => {
  if (!isBrowser) {
    return {}
  }
  return {
    queryParams: queryParams(window.location.search),
    pathname: window.location.pathname
  }
}
